import { EventEmitter, Injectable, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DataService {
  private cancelSubscriptionEvent = new Subject<any>();
  private resetpasswordToken;
  private roleObj;
  private assessmentQuestions: any;

  constructor() {
    this.assessmentQuestions = [];
  }

  assessmentName: Subject<any> = new Subject();

  setAssessmentName(name) {
    this.assessmentName.next(name);
  }

  setResetpasswordToken(val) {
    this.resetpasswordToken = val;
  }

  getResetpasswordToken() {
    return this.resetpasswordToken;
  }

  setRole(val) {
    this.roleObj = val;
  }

  getRole() {
    return this.roleObj;
  }

  setQuestionToAssessment(question) {
    if (this.assessmentQuestions.some(obj => obj._id === question._id)) {
      const removeIndex = this.assessmentQuestions.findIndex(itm => itm._id === question._id);
      this.assessmentQuestions.splice(removeIndex, 1);
    } else {
      this.assessmentQuestions.push(question);
    }
  }

  removeQuestionFromAssessment(question) {
    const removeIndex = this.assessmentQuestions.findIndex(itm => itm._id === question._id);
    this.assessmentQuestions.splice(removeIndex, 1);
  }

  setQuestionsToAssessment(questions) {
    this.assessmentQuestions = questions;
  }

  getQuestionsToAssessment() {
    return this.assessmentQuestions;
  }

  getQuestionsByQuestionType(questions: any = [], questionType: string) {
    return questions?.filter((item) => {
      // Handle deleted questions by checking if they were originally of the requested type
      if (item?.questionType === 'UNKNOWN' && item?._id === 'deleted-question') {
        // For deleted questions, show them in all sections so they are visible
        // This ensures deleted questions are displayed regardless of their original type
        // Add default options for MCQ display if they don't exist
        if (questionType === 'MULTIPLE_CHOICE' && !item.options) {
          item.options = ['Question has been deleted or is unavailable'];
        }
        return true;
      }
      return item?.questionType === questionType;
    }) || [];
  }

  /** Cancel subscription complete event. */
  cancelSubscriptionClicked(event) {
    this.cancelSubscriptionEvent.next(event);
  }

  get cancelSubscriptionClicked$() {
    return this.cancelSubscriptionEvent.asObservable();
  }

  /** Clear all user-specific data - should be called on logout */
  clearUserData(): void {
    this.resetpasswordToken = null;
    this.roleObj = null;
    this.assessmentQuestions = [];
    this.assessmentName.next(null);
  }

}
